



























import { Component, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import ContactDto from '@/models/Contacts/ContactDto';
import ContactStatus from '@/models/Contacts/ContactStatus';

@Component({
    name: 'ContactStatusEdit'
})
export default class extends GiganautVueDialog {
 
  contactStatus = ContactStatus;

	@Prop({required: true})
  contact: ContactDto

  async setStatus(status: ContactStatus) {
    const contact = JSON.parse(JSON.stringify(ContactDetailsModule.currentContact));
    if (contact.status !== status) {
      contact.status = status;
      await ContactDetailsModule.editStatus(contact);
    }
  }
}
